<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getStockOpnameResults"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-sto-result-number" label-cols-sm="4" label-cols-lg="3" label="STO Result Number" label-for="filter-sto-result-number" size="sm" :model.sync="filter.stoResultNumber" />
					<app-input-combobox-autocomplete :options="stockOpnames" optionsLabel="stockOpnameLabelCombo" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Stock Opname" id="filter-" size="sm" :model.sync="filter.stockOpnameId" @input="getStockOpnames" />
					</b-col>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="areas" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Area" id="filter-" size="sm" :model.sync="filter.areaId" @input="getAreas" />
					<app-input-combobox-autocomplete :options="stockOpnamePlans" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Stock Opname Plan" id="filter-" size="sm" :model.sync="filter.stockOpnamePlanId" @input="getStockOpnamePlans" />

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getStockOpnameResults"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Stock Opname Result</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<b-overlay
							:show="isCreateBusy"
							opacity="0.6"
							spinner-small
							spinner-variant="default"
							class="d-inline">
                            <b-button class="btn-create btn-fill-success" href="files/stockopnameresult/StockOpnameResult.xlsx" size="sm"> <b-icon-wallet class="mr-1"></b-icon-wallet>Download Template</b-button>
                        </b-overlay>
                        <b-overlay
							:show="isCreateBusy"
							opacity="0.6"
							spinner-small
							spinner-variant="default"
							class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="showPopupUploadData" size="sm"> <b-icon-upload class="mr-1"></b-icon-upload>Upload Data</b-button>
                        </b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
							:show="isCreateBusy"
							opacity="0.6"
							spinner-small
							spinner-variant="default"
							class="d-inline">
							<b-button class="btn-create btn-fill-success" @click="showPopupUploadData" size="sm"> <b-icon-upload class="mr-1"></b-icon-upload>Upload Data</b-button>
                        </b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button v-if="true" class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
					
					<b-overlay v-if="false"
							   :show="isDeleteBusy"
							   rounded
							   opacity="0.6"
							   spinner-small
							   spinner-variant="primary"
							   class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>
					
					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table sticky-header="565px" :stacked="isStacked" id="table-list-stockopnameresult" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="stockOpnameResults" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="stockOpnameResults.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
						<b-th stacked-heading="STO Result Number" class="table-filter">
							<b-form-input id="input-sto-result-number-table" @input="getStockOpnameResultsWithoutLoading" v-model="filter.stoResultNumber" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Stock Opname" class="table-filter">
							<v-select append-to-body label="stockOpnameLabelCombo" :options="stockOpnames" :value="filter.stockOpnameId" :reduce="item => item.id" v-model="filter.stockOpnameId" :filterable="true" @input="getStockOpnameResultsWithoutLoading" @search="getStockOpnames"></v-select>
						</b-th>
						<!-- <b-th stacked-heading="File Upload" class="table-filter">
							<b-form-input id="input-file-upload-table" @input="getStockOpnameResultsWithoutLoading" v-model="filter.fileUploadOriginalFilename" size="sm"></b-form-input>
						</b-th> -->
						<b-th stacked-heading="Area" class="table-filter">
							<v-select append-to-body label="code" :options="areas" :value="filter.areaId" :reduce="item => item.id" v-model="filter.areaId" :filterable="true" @input="getStockOpnameResultsWithoutLoading" @search="getAreas" ></v-select>
						</b-th>
						<b-th stacked-heading="Stock Opname Plan" class="table-filter">
							<v-select append-to-body label="name" :options="stockOpnamePlans" :value="filter.stockOpnamePlanId" :reduce="item => item.id" v-model="filter.stockOpnamePlanId" :filterable="true" @input="getStockOpnameResultsWithoutLoading" @search="getStockOpnamePlans"></v-select>
						</b-th>
						<b-th stacked-heading="Case Qty System" class="table-filter">
							<b-form-input id="input-total-qty-system-table" @input="getStockOpnameResultsWithoutLoading" v-model="filter.totalQtySystem" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Actual Qty" class="table-filter">
							<b-form-input id="input-total-qty-actual-table" @input="getStockOpnameResultsWithoutLoading" v-model="filter.totalQtyActual" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Difference" class="table-filter">
							<b-form-input id="input-total-difference-qty-table" @input="getStockOpnameResultsWithoutLoading" v-model="filter.totalDifferenceQty" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Differencet Percentage" class="table-filter">
							<b-form-input id="input-total-differencet-percentage-qty-table" @input="getStockOpnameResultsWithoutLoading" v-model="filter.totalDifferencetPercentageQty" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Total Price Qty System" class="table-filter">
							<b-form-input id="input-total-price-qty-system-table" @input="getStockOpnameResultsWithoutLoading" v-model="filter.totalPriceQtySystem" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Total Price Qty Actual" class="table-filter">
							<b-form-input id="input-total-price-qty-actual-table" @input="getStockOpnameResultsWithoutLoading" v-model="filter.totalPriceQtyActual" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Total Difference Price" class="table-filter">
							<b-form-input id="input-total-difference-price-table" @input="getStockOpnameResultsWithoutLoading" v-model="filter.totalDifferencePrice" size="sm"></b-form-input>
						</b-th>
					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(storesultnumber)="row">

                		<a @click="() => ( $router.push({ name: 'stockopnameresultdetail', params : { id: row.item.id } }))" class="a-link-detail">
							{{ row.item.stoResultNumber != null && row.item.stoResultNumber != "" ?
								(typeof row.item.productCode == 'string') ?
									row.item.stoResultNumber.slice(0, 30) + (row.item.stoResultNumber.length > 30 ? "..." : "" ) : row.item.stoResultNumber : "" }}
						</a>
            
					</template>

			<template v-slot:cell(stockOpname)="row">
				{{ row.item.stockOpname != null ? row.item.stockOpname.stockOpnameLabelCombo : "" }}
			</template>
			<template v-slot:cell(fileUpload)="row">
				{{ row.item.fileUpload != null ? row.item.fileUpload.originalFilename : "" }}
			</template>
			<template v-slot:cell(area)="row">
				{{ row.item.area != null ? row.item.area.code : "" }}
			</template>
			<template v-slot:cell(stockOpnamePlan)="row">
				{{ row.item.stockOpnamePlan != null ? row.item.stockOpnamePlan.name : "" }}
			</template>

			<template v-slot:cell(totalQtySystem)="row">
				{{ row.item.totalQtySystem!=null && row.item.totalQtySystem!=undefined ? row.item.totalQtySystem.toLocaleString():"" }}
			</template>
			<template v-slot:cell(totalQtyActual)="row">
				{{ row.item.totalQtyActual!=null && row.item.totalQtyActual!=undefined ? row.item.totalQtyActual.toLocaleString():"" }}
			</template>
			<template v-slot:cell(totalDifferenceQty)="row">
				{{ row.item.totalDifferenceQty!=null && row.item.totalDifferenceQty!=undefined ? row.item.totalDifferenceQty.toLocaleString():"" }}
			</template>
			<template v-slot:cell(totalDifferencetPercentageQty)="row">
				{{ row.item.totalDifferencetPercentageQty!=null && row.item.totalDifferencetPercentageQty!=undefined ? row.item.totalDifferencetPercentageQty.toLocaleString():"" }}
			</template>
			<template v-slot:cell(totalPriceQtySystem)="row">
				{{ row.item.totalPriceQtySystem!=null && row.item.totalPriceQtySystem!=undefined ? row.item.totalPriceQtySystem.toLocaleString():"" }}
			</template>
			<template v-slot:cell(totalPriceQtyActual)="row">
				{{ row.item.totalPriceQtyActual!=null && row.item.totalPriceQtyActual!=undefined ? row.item.totalPriceQtyActual.toLocaleString():"" }}
			</template>
			<template v-slot:cell(totalDifferencePrice)="row">
				{{ row.item.totalDifferencePrice!=null && row.item.totalDifferencePrice!=undefined ? row.item.totalDifferencePrice.toLocaleString():"" }}
			</template>

					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2" v-if="false">
							<b-form-checkbox :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<!-- <app-input-fileupload id="fieldset-file-upload" label-cols-lg="12"  label="File Upload" size="sm" :model.sync="fileUpload"  :currentModel="row.item.fileUpload"  :isEditable="false" :isUpdatable="true" /> -->
						<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.areaId" label="Area" :selected="row.item.area != null ? row.item.area.code : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="name" label-cols-sm="12" :model="row.item.stockOpnamePlanId" label="Stock Opname Plan" :selected="row.item.stockOpnamePlan != null ? row.item.stockOpnamePlan.name : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-total-qty-system" label-cols-lg="12"  label="Case Qty System" label-for="input-total-qty-system" size="sm" :model.sync="row.item.totalQtySystem"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-total-qty-actual" label-cols-lg="12"  label="Actual Qty" label-for="input-total-qty-actual" size="sm" :model.sync="row.item.totalQtyActual"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-total-difference-qty" label-cols-lg="12"  label="Difference" label-for="input-total-difference-qty" size="sm" :model.sync="row.item.totalDifferenceQty"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-total-differencet-percentage-qty" label-cols-lg="12"  label="Differencet Percentage" label-for="input-total-differencet-percentage-qty" size="sm" :model.sync="row.item.totalDifferencetPercentageQty"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-total-price-qty-system" label-cols-lg="12"  label="Total Price Qty System" label-for="input-total-price-qty-system" size="sm" :model.sync="row.item.totalPriceQtySystem"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-total-price-qty-actual" label-cols-lg="12"  label="Total Price Qty Actual" label-for="input-total-price-qty-actual" size="sm" :model.sync="row.item.totalPriceQtyActual"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-total-difference-price" label-cols-lg="12"  label="Total Difference Price" label-for="input-total-difference-price" size="sm" :model.sync="row.item.totalDifferencePrice"   :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(stockOpnameResultsPaging != null ? stockOpnameResultsPaging.dataCount : 0)"
									:per-page="(stockOpnameResultsPaging != null ? stockOpnameResultsPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
        <Upload :openPopup="showPopupUpload"
            @resetMethod="resetModalUpload"
            @uploadButtonMethod="uploadData" />
        <PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    

    ::v-deep #table-list-stockopnameresult.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

	::v-deep #table-list-stockopnameresult.b-table>thead>tr>th {
		background: #e28b29;
	}

    ::v-deep #table-list-stockopnameresult.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import StockOpnameResult from '@/models/StockOpnameResult/StockOpnameResult';
import StockOpnameResultList from '@/models/StockOpnameResult/StockOpnameResultList';
import StockOpnameResultFilter from '@/filters/StockOpnameResult/StockOpnameResultFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import StockOpnameFilter from '@/filters/StockOpname/StockOpnameFilter';
import StockOpname from '@/models/StockOpname/StockOpname';
import AttachmentFilter from '@/filters/Core/AttachmentFilter';
import Attachment from '@/models/Core/Attachment';
import AreaFilter from '@/filters/Area/AreaFilter';
import Area from '@/models/Area/Area';
import StockOpnamePlanFilter from '@/filters/StockOpnamePlan/StockOpnamePlanFilter';
import StockOpnamePlan from '@/models/StockOpnamePlan/StockOpnamePlan';
import AppInputTextbox from '@/components/AppInputTextbox';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import UserInfo from '@/models/UserInfo/UserInfo';
import StockOpnameDetailFilter from '@/filters/StockOpname/StockOpnameDetailFilter';
import StockOpnameDetail from '@/models/StockOpname/StockOpnameDetail';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {
		StockOpnameResult, 
		StockOpnameResultList, 
		StockOpnameResultFilter, 
		AppLabel,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputTextbox,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				{"stoResultNumber": {}, "class" : "th-sto-result-number first-child", "label" : "STO Result Number", key: 'stoResultNumber', sortable: true}, 
				{"stockOpname": {}, "class" : "th-stock-opname", "label" : "Stock Opname", key: 'stockOpname', sortable: true}, 
				// {"fileUpload": {}, "class" : "th-file-upload last-child", "label" : "File Upload", key: 'fileUpload', sortable: true}, 
				{"area": {}, "class" : "th-area d-stack-none", "label" : "Area", key: 'area', sortable: true}, 
				{"stockOpnamePlan": {}, "class" : "th-stock-opname-plan d-stack-none", "label" : "Stock Opname Plan", key: 'stockOpnamePlan', sortable: true}, 
				{"totalQtySystem": {}, "class" : "th-total-qty-system d-stack-none text-right", "label" : "Case Qty System", key: 'totalQtySystem', sortable: true}, 
				{"totalQtyActual": {}, "class" : "th-total-qty-actual d-stack-none text-right", "label" : "Actual Qty", key: 'totalQtyActual', sortable: true}, 
				{"totalDifferenceQty": {}, "class" : "th-total-difference-qty d-stack-none text-right", "label" : "Difference", key: 'totalDifferenceQty', sortable: true}, 
				{"totalDifferencetPercentageQty": {}, "class" : "th-total-differencet-percentage-qty d-stack-none text-right", "label" : "Differencet Percentage", key: 'totalDifferencetPercentageQty', sortable: true}, 
				{"totalPriceQtySystem": {}, "class" : "th-total-price-qty-system d-stack-none text-right", "label" : "Total Price Qty System", key: 'totalPriceQtySystem', sortable: true}, 
				{"totalPriceQtyActual": {}, "class" : "th-total-price-qty-actual d-stack-none text-right", "label" : "Total Price Qty Actual", key: 'totalPriceQtyActual', sortable: true}, 
				{"totalDifferencePrice": {}, "class" : "th-total-difference-price d-stack-none text-right", "label" : "Total Difference Price", key: 'totalDifferencePrice', sortable: true}, 

				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			stockOpnameResults: [],
			stockOpnameResultsPaging: {},
			stockOpnames : [],
			areas : [],
			stockOpnamePlans : [],
			stockOpnameResultDetails : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: false,
			
		}
	},	methods : {
		getStockOpnameResults : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			this.filter.isInProgressPlan = true;

			StockOpnameResult.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.stockOpnameResults = result.data
					this.stockOpnameResultsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getStockOpnameResultsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			this.filter.isInProgressPlan = true;

			StockOpnameResult.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.stockOpnameResults = result.data
					this.stockOpnameResultsPaging = result
				}
			})
			.catch(error => {});
		},
		getStockOpnames : async function(input) {
			let filter = new StockOpnameFilter();
			if (input != undefined) {
				filter.stockOpnamePlan = input;
			}
			await StockOpname.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.stockOpnames = result.data
				}
			})
			.catch(error => {});
		},
		getAreas : async function(input) {
			let filter = new AreaFilter();
			if (input != undefined) {
				filter.code = input;
			}
			await Area.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.areas = result.data
				}
			})
			.catch(error => {});
		},
		getStockOpnamePlans : async function(input) {
			let filter = new StockOpnamePlanFilter();
			if (input != undefined) {
				filter.stockOpnameLabelCombo = input;
			}
			await StockOpnamePlan.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.stockOpnamePlans = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new StockOpnameResultFilter();
			this.getStockOpnameResults();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getStockOpnameResults();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				StockOpnameResult.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			StockOpnameResult.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			StockOpnameResult.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},
		createData() {
			this.isCreateBusy = true;
			StockOpnameResult.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						let createRoute = 'stockopnameresultedit';
						if(this.isScannerMode) {
							createRoute = 'stockopnameresultscan';
						}

						this.$router.push({ name: createRoute, params : { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			StockOpnameResult.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'stockopnameresultedit', params : { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},

		deleteData(id) {
			StockOpnameResult.deleteData(this, id).then(result => {
				if (result)
				{
					this.getStockOpnameResults();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				StockOpnameResult.deleteMultipleData(this).then(result => {
					this.getStockOpnameResults();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableStockOpnameResultParent = document.getElementById('table-list-stockopnameresult').parentNode;
			tableStockOpnameResultParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableStockOpnameResultParent.scrollWidth - tableStockOpnameResultParent.offsetWidth) == Math.ceil(tableStockOpnameResultParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableStockOpnameResultParent = document.getElementById('table-list-stockopnameresult').parentNode;
			tableStockOpnameResultParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableStockOpnameResultParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new StockOpnameResultFilter();
		this.getStockOpnames()
		this.getAreas()
		this.getStockOpnamePlans()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Stock Opname Result"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getStockOpnameResults();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getStockOpnameResults();
			}
		},
		sortDesc: {
			handler: function() {
				this.getStockOpnameResults();
			}
		},
		currentPage: {
			handler: function() {
				this.getStockOpnameResults();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getStockOpnameResults();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				StockOpnameResult.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "stockopnameresultindex") {
					this.getStockOpnameResultsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "stock_opname_result").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
